<template>
  <div class="d-flex flex-column overflow-hidden h-100">
    <vue-custom-scrollbar
      class="app-content-padding flex-grow-1 overflow-hidden h-100"
    >
      <ts-page-title
        :title="$t('examRegister.pageTitle')"
        :breadcrumb="[
          { text: $t('home'), href: '/' },
          {
            text: $t('examRegister.pageTitle'),
            href: '/admin/academic/exam-registers',
          },
          {
            text: $t('create'),
            active: true,
          },
        ]"
      />
      <ts-loading-banner :loading="waiting">
        <div class="row">
          <div class="col-md-6">
            <candidate-templete v-model="model" :validation="errors" />
          </div>
          <div class="col-md-6">
            <exam-registed-templete
              v-model="model"
              :validation="errors"
              class="tw-h-full"
            />
          </div>
        </div>
      </ts-loading-banner>
    </vue-custom-scrollbar>
    <div
      id="footer"
      class="app-footer m-0 tw-flex tw-justify-end tw-space-x-2 tw-sh"
      style="background-color: #e9ecef"
    >
      <ts-button
        @click.prevent="$router.push({ name: 'exam-register' })"
        :disabled="waiting_new || waiting"
        class="btn-gray"
      >
        {{ $t("cancel") }}</ts-button
      >
      <ts-button
        color="primary"
        outline
        :waiting="waiting_new"
        :disabled="waiting_new || waiting"
        @click.prevent="onSaveAddNew"
      >
        {{ $t("saveAddNew") }}</ts-button
      >
      <ts-button
        color="primary"
        :waiting="waiting"
        :disabled="waiting_new || waiting"
        @click.prevent="onSave"
      >
        {{ $t("save") }}</ts-button
      >
    </div>
  </div>
</template>

<script>
import AppOptions from "@/config/AppOptions.vue";
import CandidateTemplete from "./components/candidate.vue";
import ExamRegistedTemplete from "./components/exam-registed.vue";
import { mapActions } from "vuex";
import { Errors } from "form-backend-validation";

export default {
  name: "examRegisterCreate",
  components: {
    CandidateTemplete,
    ExamRegistedTemplete,
  },
  data() {
    return {
      loading: false,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      model: {
        course_skill_id: null,
        candidate_list: [],
        is_evaluated: false,
        candidateRegisted: [],
        exam_date: null,
        time_start: null,
        time_stop: null,
      },
    };
  },
  created() {
    AppOptions.appContentFullHeight = true;
    AppOptions.appContentClass = "p-0";
  },
  computed: {},
  methods: {
    ...mapActions("academic/examRegister", ["getFormViewData"]),
    async fetchFormViewModel({ params, index }) {
      this.waiting = true;
      await this.getFormViewData({
        index: index,
        params: params,
      });
      this.waiting = false;
    },
    async onSaveAddNew() {
      this.errors = new Errors();
      this.waiting_new = true;
      this.$store
        .dispatch("academic/examRegister/store", Object.assign({}, this.model))
        .then(async (response) => {
          this.$notify({
            type: "success",
            text: response.message,
          });
          this.clearInput();
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting_new = false;
        });
    },
    async onSave() {
      this.errors = new Errors();
      this.waiting = true;
      this.$store
        .dispatch("academic/examRegister/store", Object.assign({}, this.model))
        .then(async (response) => {
          this.$notify({
            type: "success",
            text: response.message,
          });
          this.clearInput();
          this.$router.push({ name: "exam-register" });
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    clearError() {
      this.errors = new Errors();
    },
    clearInput() {
      (this.model.course_skill_id = null),
        (this.model.candidateRegisted = []),
        (this.model.candidate_list = []),
        (this.model.is_evaluated = false),
        (this.model.exam_date = null),
        (this.model.time_start = null),
        (this.model.time_stop = null);
      this.fetchFormViewModel({ params: {}, index: undefined });
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchFormViewModel({ params: {}, index: undefined });
    });
  },
  beforeRouteLeave(to, from, next) {
    AppOptions.appContentFullHeight = false;
    AppOptions.appContentClass = "";
    next();
  },
};
</script>
